import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { useParams } from "react-router-dom";
import { jsPDF } from 'jspdf';
import { useAuth } from "../../../AuthContext";
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link } from "react-router-dom";
import QuestionPaperTPT from "./QuestionPaperTPT";
import QuestionPaperTestSeries from "./QuestionPaperTestSeries";

const QuestionPaper = () => {
    const { logout, user } = useAuth();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const contentRef = React.useRef();
    const params = useParams();
    const [exam, setExam] = useState([]);
    const [generating,setGenerating]=useState(false)
    const generatePdf = async () => {
        setGenerating(true)
        try {

            const response = await axios.post(`${baseUrl}/generate-pdf`, {
                htmlContent: contentRef.current ? contentRef.current.innerHTML : '',fileName:`${exam.className}-${exam.examName}-Question Paper.pdf`
            }, { responseType: 'json' });

            const pdfUrl = `${baseUrl}${response.data.fileUrl}`;

            const link = document.createElement('a');
            link.href = pdfUrl;
            link.target = '_blank';
            link.click();
            setGenerating(false)
        } catch (error) {
            console.error('Error generating PDF:', error);
            setGenerating(false)
        }
    };
    const downloadPDF = () => {
        const doc = new jsPDF();

        const content = contentRef.current;
        const contentWidth = content.offsetWidth;
        const contentHeight = content.offsetHeight;

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const margin = 0;

        const scaleX = (pageWidth - 2 * margin) / contentWidth;
        const scaleY = (pageHeight - 2 * margin) / contentHeight;

        let scale = Math.max(scaleX, scaleY);

        const maxScale = 1;
        scale = Math.min(scale, maxScale);

        const x = margin;
        const y = margin;

        if (contentWidth > contentHeight) {
            doc.setOrientation('landscape');
        }

        doc.html(content, {
            callback: function (doc) {
                doc.save(`${exam.examName} Question Paper.pdf`);
            },
            x: x,
            y: y,
            html2canvas: {
                scale: scale,
                useCORS: true,
            },
        });
    };

    const getExam = () => {
        axios.get(`${baseUrl}/exam/question-paper?examId=${params.id}`)
            .then(res => setExam(res.data))
            .catch(e => console.log(e));
    };

    useEffect(() => {
        getExam();
    }, []);

    const filterAndMapQuestions = (subject) => {
        const filteredQuestions = exam.questionPaper?.filter(q => q.subject === subject);
        return filteredQuestions
    };

    const TPTQuestions=exam.questionPaper;

    return (
        <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
            <aside
                className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}
            >
                <SideBar />
            </aside>
            <main className={styles.mainContent}>
                <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
                <nav aria-label="breadcrumb" >
                    <ol className="breadcrumb">
                        <div className="d-flex flex-grow-1">
                            <li className="breadcrumb-item">
                                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to='/admin/exams' className="text-decoration-none">All Exams</Link>
                            </li>
                            <li className="breadcrumb-item active">
                                Question Paper
                            </li>
                        </div>
                        <li className="nav-item dropdown">
                            <span
                                className="nav-link dropdown-toggle"
                                data-bs-toggle="dropdown"
                                href=""
                                role="button"
                                aria-expanded="false"
                            >
                                Welcome, {user.name}
                                <i className="ml-2 fa fa-angle-down"></i>
                            </span>
                            <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                                <li>
                                    <span className="dropdown-item" onClick={logout}>
                                        Logout
                                    </span>
                                </li>
                            </ul>
                        </li>
                    </ol>
                </nav>
                <button className="btn btn-success btn-sm mb-2" disabled={generating} onClick={generatePdf}>{generating?<>generating... <img src="/assets/images/waiting.gif" width='25px' alt="loading"/></>:'Generate PDF'}</button>
                <div
                    ref={contentRef}
                    className="container"
                    style={{ backgroundColor: "white" }}
                >
                    {
                        exam.examType==='TPT'?
                        <QuestionPaperTPT exam={exam} TPTQuestions={TPTQuestions}/>
                        :
                        <QuestionPaperTestSeries exam={exam} filterAndMapQuestions={filterAndMapQuestions}/>

                    }
                </div>
            </main>
        </div>
    );
};

export default QuestionPaper;
